import { useTheme, useMediaQuery, Breakpoint } from '@mui/material';

const useMobileBreakpoint = (val: Breakpoint) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(val));
};

export default useMobileBreakpoint;
